module.exports = __webpack_public_path__ + "img/alert-red.50fd5761.svg";